import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../auth';
import { SidebarComponent, TableRuanganDark, TableRuanganLight } from '../../components';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import axios from '../../api/axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import RingLoader from 'react-spinners/RingLoader';


function Ruangan() {
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const { showSidebar, tokens } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [listRuangan, setListRuangan] = useState([]);
    const [loading, setLoading] = useState(true);
    const tokenUser = tokens?.token;
    const navigate = useNavigate();

    const retrieveRuangan = () => {
        setLoading(true);
        const startTime = Date.now(); // Track start time
        axios.get(`/manage/ruangan/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setListRuangan(res.data);
                // Ensure loading lasts at least 2 seconds
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            }).catch(err => {
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);

                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });
                    } else {
                        console.error(err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Gagal memuat data pada server!',
                        });
                    }
                }, delay);
            })
    }

    useEffect(() => {
        if (tokenUser !== undefined) retrieveRuangan()
    }, [tokenUser]);


    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            {loading && (
                <div id={theme === 'light' ? 'loading-overlay-dark' : 'loading-overlay-light'}>
                    <RingLoader
                        size={80}
                        color={theme === 'light' ? '#D2DC02' : '#10B1AA'}
                    />
                </div>
            )}
            {!loading && (
                <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                    style={{
                        width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '80px' : '210px'})`,
                        marginLeft: isMobile ? '0px' : showSidebar ? '80px' : '210px',
                        transition: '0.8s'
                    }}
                >
                    <div className={isMobile ? '' : 'ms-3'}>
                        <Row>
                            <Col xs={12} lg={6} className='text-start'>
                                <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '28px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                    Daftar Ruangan
                                </h3>
                            </Col>
                        </Row>
                    </div>
                    <div className={isMobile ? 'pt-4' : 'mx-3 pt-4'}>
                        {theme === 'light' ? (
                            <TableRuanganDark
                                listRuangan={listRuangan}
                                retrieveRuangan={retrieveRuangan}
                                tokenUser={tokenUser}
                            />
                        ) : (
                            <TableRuanganLight
                                listRuangan={listRuangan}
                                retrieveRuangan={retrieveRuangan}
                                tokenUser={tokenUser}
                            />
                        )}
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            )}
        </div>
    )
}

export default Ruangan
